// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/c5992d44/" + chunkId + "." + __webpack_require__.h() + ".vc5992d44.js";
};